export enum BridgeRows {
    SoldBridge = 'Sold Bridge',
    TotalBridgeRet = 'Total Bridge Ret.',
    BridgeSummary = 'Bridge',
}
